import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ProfileRoutes = defineRoute({
    update: {
        route: {
            path: "/profile",
            component: () => loadView(import("./ProfileUpdate.vue")),
        },
    },
});
